// extracted by mini-css-extract-plugin
export default {"image":"SU-z","loaded":"TU-z","placeholder":"UU-z"};